import { render, staticRenderFns } from "./new_branch.vue?vue&type=template&id=33642b68&scoped=true"
import script from "./new_branch.vue?vue&type=script&lang=js"
export * from "./new_branch.vue?vue&type=script&lang=js"
import style0 from "./new_branch.vue?vue&type=style&index=0&id=33642b68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33642b68",
  null
  
)

export default component.exports